<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

// Ilustração de QR + EMV fictício (apenas quando o backend ainda não enviou PIX)
const PIX_DEMO_QR_DATA_URI =
  "data:image/svg+xml," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">' +
      '<rect fill="#fff" width="100" height="100"/>' +
      '<g fill="#1a1a1a">' +
      '<path d="M8 8h24v24H8zm8 8h8v8h-8zm36-16h24v24H44zm8 8h8v8h-8zm-44 28h8v8H8zm16 0h8v8h-8zm16 0h24v8H40zm8 8h8v8h-8zm-56 8h8v8H8zm24 0h16v8H32zm24 0h8v8h-8zm8 0h8v8h-8zm-64 8h8v8H8zm16 0h8v8h-8zm8 0h8v8h-8zm16 0h8v8h-8zm8 0h8v8h-8zm8 0h8v8h-8zm-64 8h24v24H8zm8 8h8v8h-8zm36-8h24v24H52zm8 8h8v8h-8z"/>' +
      "</g>" +
      "</svg>"
  );

const PIX_COPY_EXAMPLE =
  "00020126580014br.gov.bcb.pix0136exemplo00000000-0000-0000-0000-0000000000005204000053039865802BR5913DEMONSTRACAO6009SAO PAULO62070503***6304ABCD";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      order: null,
      ebook: null,
      methods: null,
      loading: true,
      polling: null,
      copyFeedback: false,
      balance: {
        loading: false,
        loaded: false,
        total: "0.00",
        pay: -1,
      },
    };
  },
  computed: {
    pixPayload() {
      const m = this.methods;
      if (
        !m ||
        !m.pix ||
        !m.pix.pix ||
        !m.pix.pix.text
      ) {
        return null;
      }
      return m.pix.pix;
    },
    /** Texto + imagem exibidos no bloco PIX (reais ou exemplo ilustrativo). */
    displayPix() {
      if (!this.order || this.order.status !== "pending") {
        return null;
      }

      const p = this.pixPayload;

      if (!p || !p.text) {
        return {
          text: PIX_COPY_EXAMPLE,
          imageSrc: PIX_DEMO_QR_DATA_URI,
          isDemo: true,
          hasQrImage: true,
        };
      }

      return {
        text: p.text,
        imageSrc: p.image ? "data:image/png;base64," + p.image : null,
        isDemo: false,
        hasQrImage: !!p.image,
      };
    },
    showPixBlock() {
      return this.displayPix !== null;
    },
    showBalanceBlock() {
      return (
        this.order &&
        this.order.status === "pending" &&
        this.order.id_order
      );
    },
  },
  methods: {
    getOrder() {
      const id = this.$route.params.id;
      this.loading = true;
      api.get("ebooks/orders/" + encodeURIComponent(id)).then((response) => {
        this.loading = false;
        if (response.data.status === "success") {
          this.order = response.data.order;
          this.ebook = response.data.ebook || null;
          this.methods = response.data.methods || null;

          if (this.order && this.order.status === "pending") {
            this.startPoll();
            if (this.order.id_order) {
              this.getBalance();
            } else {
              this.balance.pay = -1;
              this.balance.total = "0.00";
              this.balance.loaded = false;
            }
          } else {
            this.stopPoll();
            this.balance.pay = -1;
            this.balance.total = "0.00";
            this.balance.loaded = false;
          }
        } else {
          this.order = null;
          this.ebook = null;
          this.methods = null;
          this.balance.pay = -1;
          this.balance.total = "0.00";
          this.balance.loaded = false;
        }
      }).catch(() => {
        this.loading = false;
        this.order = null;
        this.ebook = null;
        this.methods = null;
        this.balance.pay = -1;
        this.balance.total = "0.00";
        this.balance.loaded = false;
      });
    },
    getBalance() {
      if (!this.order || !this.order.id_order) {
        return;
      }
      this.balance.loaded = false;
      api
        .get("wallet/balance/network")
        .then((response) => {
          if (response.data.status === "success") {
            this.balance.total = response.data.balance.available;
            this.balance.pay =
              parseFloat(this.balance.total) - parseFloat(this.order.total);
          } else {
            this.balance.pay = -1;
          }
        })
        .catch(() => {
          this.balance.pay = -1;
        })
        .finally(() => {
          this.balance.loaded = true;
        });
    },
    payBalance() {
      if (!this.order || !this.order.id_order) {
        return;
      }
      this.balance.loading = true;
      api
        .post("wallet/pay/" + this.order.id_order)
        .then((response) => {
          if (response.data.status === "success") {
            this.$toast.success("O pedido foi pago com sucesso.");
            this.getOrder();
          } else {
            this.$toast.error(
              response.data.message ||
                "Não foi possível concluir o pagamento com saldo."
            );
          }
        })
        .catch(() => {
          this.$toast.error(
            "Ocorreu um erro ao processar o pagamento, tente novamente."
          );
        })
        .finally(() => {
          this.balance.loading = false;
        });
    },
    startPoll() {
      this.stopPoll();
      this.polling = setInterval(() => {
        const id = this.$route.params.id;
        api.get("ebooks/orders/" + encodeURIComponent(id) + "/sync").then((response) => {
          if (
            response.data.status === "success" &&
            response.data.order &&
            response.data.order.status === "paid"
          ) {
            this.stopPoll();
            this.getOrder();
          }
        });
      }, 8000);
    },
    stopPoll() {
      if (this.polling) {
        clearInterval(this.polling);
        this.polling = null;
      }
    },
    copyPixCode() {
      const text = this.displayPix && this.displayPix.text;
      if (!text) return;
      const done = () => {
        this.copyFeedback = true;
        setTimeout(() => {
          this.copyFeedback = false;
        }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => {
          this.fallbackCopy(text, done);
        });
      } else {
        this.fallbackCopy(text, done);
      }
    },
    fallbackCopy(text, onDone) {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        onDone();
      } finally {
        document.body.removeChild(ta);
      }
    },
  },
  mounted() {
    this.getOrder();
  },
  beforeDestroy() {
    this.stopPoll();
  },
};
</script>

<template>
  <Layout>
    <div class="ebook-order-page">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link tag="a" to="/">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
              <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
            </svg>
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link tag="a" to="/ebooks">E-books</router-link>
        </li>
        <li class="breadcrumb-item">Pagamento</li>
      </ol>

      <div v-if="loading" class="card ebook-state-card">
        <div class="card-body min-vh-25 d-flex justify-content-center align-items-center py-5">
          <b-spinner variant="default"></b-spinner>
        </div>
      </div>

      <div v-else-if="!order" class="card ebook-state-card">
        <div class="card-body text-center py-5">
          <p class="mb-0 text-muted">Pedido não encontrado.</p>
          <router-link class="btn btn-sm btn-outline-primary mt-3" to="/ebooks">Voltar ao catálogo</router-link>
        </div>
      </div>

      <template v-else>
        <!-- Resumo: mesmo vocabulário visual da página do ebook, compacto -->
        <div v-if="ebook" class="card ebook-detail-card ebook-order-summary">
          <div class="card-header bg-soft-default">
            <h5 class="mb-0">Pedido no. {{ order.id_order }}</h5>
          </div>
          <div class="card-body p-0">
            <div class="row no-gutters align-items-stretch ebook-order-summary-inner">
              <div class="col-auto ebook-order-cover-wrap">
                <div class="ebook-order-cover-shell">
                  <img
                    v-if="ebook.cover_url"
                    class="ebook-order-cover-img"
                    :src="ebook.cover_url"
                    :alt="ebook.title"
                  />
                  <div v-else class="ebook-order-cover-placeholder">
                    <span class="ebook-order-cover-placeholder-text">Sem capa</span>
                  </div>
                </div>
              </div>
              <div class="col ebook-order-meta">
                <h1 class="ebook-order-title">{{ ebook.title }}</h1>
                <div class="ebook-price-bar ebook-order-price-bar">
                  <span class="ebook-price-label">Total a pagar</span>
                  <span class="ebook-price-value">{{ order.total | currency }}</span>
                </div>
                <p class="ebook-order-status-line mb-0">
                  <span
                    class="ebook-order-status-badge"
                    :class="order.status === 'paid' ? 'is-paid' : 'is-pending'"
                  >
                    {{ order.status === "paid" ? "Pago" : "Aguardando pagamento" }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="card ebook-state-card">
          <div class="card-body py-4">
            <p class="mb-2 text-muted small">Pedido</p>
            <p class="mb-0">
              <strong>Total:</strong> {{ order.total | currency }}
            </p>
            <p class="mb-0 mt-2">
              <span
                class="ebook-order-status-badge"
                :class="order.status === 'paid' ? 'is-paid' : 'is-pending'"
              >
                {{ order.status === "paid" ? "Pago" : "Aguardando pagamento" }}
              </span>
            </p>
          </div>
        </div>

        <!-- PIX: QR + copia e cola (dados reais ou exemplo enquanto não chegam) -->
        <div
          v-if="showPixBlock"
          class="card ebook-pix-card"
        >
          <div class="ebook-pix-card-inner">
            <p
              v-if="displayPix.isDemo"
              class="ebook-pix-demo-notice"
              role="status"
            >
              Exemplo ilustrativo: o QR e o código abaixo serão substituídos pelo PIX real assim que estiver disponível.
            </p>

            <header class="ebook-pix-header">
              <div class="ebook-pix-header-icon" aria-hidden="true">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L4 6v6c0 5.25 3.5 9.74 8 11 4.5-1.26 8-5.75 8-11V6l-8-4z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                  <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div>
                <h2 class="ebook-pix-title">Pague com PIX</h2>
                <p class="ebook-pix-subtitle">Escaneie o QR Code ou use o copia e cola no app do seu banco.</p>
              </div>
            </header>

            <div class="ebook-pix-grid">
              <div class="ebook-pix-qr-panel">
                <div class="ebook-pix-qr-frame">
                  <img
                    v-if="displayPix.hasQrImage && displayPix.imageSrc"
                    class="ebook-pix-qr-img"
                    :src="displayPix.imageSrc"
                    alt="QR Code PIX"
                  />
                  <div
                    v-else
                    class="ebook-pix-qr-missing"
                  >
                    <span class="ebook-pix-qr-missing-icon" aria-hidden="true">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm13 0h3v3h-3v-3z" fill="currentColor" opacity=".35"/>
                        <path d="M13 13h7v7h-7v-7z" stroke="currentColor" stroke-width="1.2"/>
                      </svg>
                    </span>
                    <span class="ebook-pix-qr-missing-text">QR em geração — use o código copia e cola ao lado.</span>
                  </div>
                </div>
                <p class="ebook-pix-qr-hint">Abra o app do banco e escolha pagar com PIX por QR Code.</p>
              </div>

              <div class="ebook-pix-copy-panel">
                <label class="ebook-pix-copy-label" for="pix-copy-field">Copia e cola</label>
                <div class="ebook-pix-copy-field-wrap">
                  <textarea
                    id="pix-copy-field"
                    class="ebook-pix-textarea"
                    :class="{ 'is-demo': displayPix.isDemo }"
                    rows="5"
                    readonly
                    :value="displayPix.text"
                  ></textarea>
                </div>
                <button
                  type="button"
                  class="btn ebook-pix-copy-btn"
                  :class="{ 'is-success': copyFeedback }"
                  @click="copyPixCode"
                >
                  <span v-if="copyFeedback" class="ebook-pix-copy-btn-text">Código copiado</span>
                  <span v-else class="ebook-pix-copy-btn-text">Copiar código PIX</span>
                </button>
              </div>
            </div>

            <p class="ebook-pix-footnote">
              Após o pagamento, esta página atualiza automaticamente em alguns segundos.
            </p>
          </div>
        </div>

        <!-- Saldo: mesmo padrão visual do bloco PIX -->
        <div
          v-if="showBalanceBlock"
          class="card ebook-balance-card"
        >
          <div class="ebook-balance-card-inner">
            <header class="ebook-balance-header">
              <div class="ebook-balance-header-icon" aria-hidden="true">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z" fill="currentColor"/>
                </svg>
              </div>
              <div>
                <h2 class="ebook-balance-title">Pague com saldo</h2>
                <p class="ebook-balance-subtitle">
                  Use o saldo disponível na sua carteira para quitar este pedido na hora.
                </p>
              </div>
            </header>

            <div class="ebook-balance-body">
              <div
                v-if="!balance.loaded"
                class="ebook-balance-loading d-flex justify-content-center py-4"
              >
                <b-spinner variant="default" small role="status" />
              </div>
              <template v-else-if="balance.pay >= 0">
                <p class="ebook-balance-text">Deseja pagar este pedido com o seu saldo?</p>
                <p class="ebook-balance-amounts">
                  Seu saldo atual é de <strong>{{ balance.total | currency }}</strong>
                  e, após o pagamento, será de
                  <strong>{{ (parseFloat(balance.total) - parseFloat(order.total)) | currency }}</strong>.
                </p>
                <button
                  type="button"
                  class="btn ebook-balance-confirm-btn"
                  :disabled="balance.loading"
                  @click="payBalance"
                >
                  Confirmar pagamento com saldo
                  <b-spinner
                    v-if="balance.loading"
                    small
                    class="ml-2 align-middle"
                    variant="light"
                    role="status"
                  />
                </button>
              </template>
              <template v-else>
                <p class="ebook-balance-text ebook-balance-text-muted">
                  No momento você não possui saldo suficiente para realizar o pagamento do pedido.
                </p>
              </template>
            </div>
          </div>
        </div>

        <div v-if="order.status === 'paid'" class="card ebook-paid-card">
          <div class="ebook-paid-body">
            <p class="ebook-paid-title">Pagamento confirmado</p>
            <p class="ebook-paid-text">Acesse sua biblioteca para baixar o arquivo.</p>
            <router-link class="btn btn-default ebook-paid-btn" to="/ebooks/library">Abrir biblioteca</router-link>
          </div>
        </div>
      </template>
    </div>
  </Layout>
</template>

<style scoped>
.ebook-order-page {
  --ebook-ink: #1a1512;
  --ebook-muted: #6b6560;
  --ebook-default-tint: #f5f2f8;
  --ebook-default-tint-deep: #ebe4f2;
  --ebook-accent: #452058;
  --ebook-accent-soft: rgba(69, 32, 88, 0.08);
  --ebook-radius: 8px;
  --ebook-card-border: 1px solid rgba(0, 0, 0, 0.125);
  --ebook-pix-green: #0d7a5c;
  --ebook-pix-green-soft: rgba(13, 122, 92, 0.12);
}

.ebook-state-card {
  border: var(--ebook-card-border);
}

.ebook-detail-card {
  border: var(--ebook-card-border);
  overflow: hidden;
  background: #fff;
  margin-bottom: 1.25rem;
}

.ebook-order-summary-inner {
  min-height: 0;
  gap: .8rem;
}

.ebook-order-cover-wrap {
  background: var(--ebook-default-tint);
  padding: 1rem 1rem 1rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 575px) {
  .ebook-order-cover-wrap {
    padding: 1rem;
    justify-content: flex-start;
  }
}

.ebook-order-cover-shell {
  width: 112px;
  flex-shrink: 0;
}

.ebook-order-cover-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 6px;
}

.ebook-order-cover-placeholder {
  aspect-ratio: 2 / 3;
  width: 100%;
  background: var(--ebook-default-tint-deep);
  border: 2px dashed rgba(69, 32, 88, 0.2);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ebook-order-cover-placeholder-text {
  font-size: 0.7rem;
  color: var(--ebook-muted);
  text-align: center;
  padding: 0.25rem;
}

.ebook-order-meta {
  padding: 1.1rem 1.25rem 1.15rem 0.75rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (min-width: 576px) {
  .ebook-order-meta {
    padding: 1.35rem 1.5rem 1.35rem 0.5rem;
  }
}

.ebook-order-title {
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.3;
  color: var(--ebook-ink);
  letter-spacing: -0.02em;
  margin-bottom: 0.75rem;
}

@media (min-width: 576px) {
  .ebook-order-title {
    font-size: 1.3rem;
  }
}

.ebook-price-bar {
  padding: 0.65rem 0.85rem;
  margin-bottom: 0.75rem;
  border-radius: 8px;
  background: var(--ebook-accent-soft);
  border: 1px solid rgba(69, 32, 88, 0.12);
}

.ebook-order-price-bar {
  margin-bottom: 0.65rem;
}

.ebook-price-label {
  display: block;
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--ebook-accent);
  margin-bottom: 0.15rem;
}

.ebook-price-value {
  display: block;
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--ebook-accent);
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.ebook-order-status-line {
  margin-top: auto;
}

.ebook-order-status-badge {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
}

.ebook-order-status-badge.is-pending {
  background: rgba(180, 120, 40, 0.12);
  color: #8a5a12;
}

.ebook-order-status-badge.is-paid {
  background: var(--ebook-pix-green-soft);
  color: var(--ebook-pix-green);
}

/* Bloco PIX */
.ebook-pix-card {
  border: var(--ebook-card-border);
  overflow: hidden;
  background: linear-gradient(165deg, #faf9fc 0%, #f3f0f7 45%, #eef6f3 100%);
  margin-bottom: 1rem;
}

.ebook-pix-card-inner {
  padding: 1.35rem 1.25rem 1.5rem;
}

@media (min-width: 576px) {
  .ebook-pix-card-inner {
    padding: 1.75rem 1.75rem 1.85rem;
  }
}

.ebook-pix-demo-notice {
  font-size: 0.82rem;
  line-height: 1.45;
  color: #6b4a0a;
  background: rgba(230, 180, 60, 0.18);
  border: 1px solid rgba(180, 130, 30, 0.35);
  border-radius: 8px;
  padding: 0.65rem 0.85rem;
  margin-bottom: 1.25rem;
}

.ebook-pix-header {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.ebook-pix-header-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: var(--ebook-pix-green-soft);
  color: var(--ebook-pix-green);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ebook-pix-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--ebook-ink);
  letter-spacing: -0.02em;
  margin: 0 0 0.35rem;
  line-height: 1.2;
}

.ebook-pix-subtitle {
  font-size: 0.9rem;
  color: var(--ebook-muted);
  margin: 0;
  line-height: 1.45;
  max-width: 36rem;
}

.ebook-pix-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .ebook-pix-grid {
    grid-template-columns: minmax(200px, 260px) 1fr;
    gap: 2rem;
    align-items: start;
  }
}

.ebook-pix-qr-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (min-width: 768px) {
  .ebook-pix-qr-panel {
    align-items: stretch;
  }
}

.ebook-pix-qr-frame {
  background: #fff;
  padding: 0.85rem;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
}

.ebook-pix-qr-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
}

.ebook-pix-qr-missing {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 1rem;
  text-align: center;
  color: var(--ebook-muted);
  background: linear-gradient(180deg, #f8f8f9 0%, #f0f0f2 100%);
  border-radius: 4px;
}

.ebook-pix-qr-missing-icon {
  color: rgba(69, 32, 88, 0.35);
}

.ebook-pix-qr-missing-text {
  font-size: 0.8rem;
  line-height: 1.4;
  max-width: 14rem;
}

.ebook-pix-qr-hint {
  font-size: 0.78rem;
  color: var(--ebook-muted);
  text-align: center;
  margin: 0.85rem 0 0;
  line-height: 1.4;
  max-width: 240px;
}

@media (min-width: 768px) {
  .ebook-pix-qr-hint {
    text-align: left;
    max-width: none;
    margin-left: 0;
  }
}

.ebook-pix-copy-panel {
  min-width: 0;
}

.ebook-pix-copy-label {
  display: block;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--ebook-muted);
  margin-bottom: 0.5rem;
}

.ebook-pix-copy-field-wrap {
  position: relative;
  margin-bottom: 0.85rem;
}

.ebook-pix-textarea {
  width: 100%;
  font-family: ui-monospace, "SF Mono", "Menlo", Monaco, Consolas, monospace;
  font-size: 0.72rem;
  line-height: 1.45;
  color: var(--ebook-ink);
  background: #fff;
  border: 1px solid rgba(69, 32, 88, 0.15);
  border-radius: 8px;
  padding: 0.75rem 0.85rem;
  resize: vertical;
  min-height: 7rem;
}

.ebook-pix-textarea:focus {
  outline: none;
  border-color: rgba(13, 122, 92, 0.45);
}

.ebook-pix-textarea.is-demo {
  border-style: dashed;
  background: rgba(255, 252, 235, 0.85);
}

.ebook-pix-copy-btn {
  width: 100%;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 0.65rem 1rem;
  background: var(--ebook-pix-green);
  border: none;
  color: #fff;
  transition: background 0.2s ease, transform 0.15s ease;
}

.ebook-pix-copy-btn:hover {
  background: #0a6349;
  color: #fff;
}

.ebook-pix-copy-btn:active {
  transform: scale(0.99);
}

.ebook-pix-copy-btn.is-success {
  background: #1a6b52;
}

.ebook-pix-footnote {
  font-size: 0.8rem;
  color: var(--ebook-muted);
  margin: 1.35rem 0 0;
  padding-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  line-height: 1.5;
  margin-bottom: 0;
}

/* Saldo */
.ebook-balance-card {
  border: var(--ebook-card-border);
  overflow: hidden;
  background: linear-gradient(165deg, #faf9fc 0%, #f5f0f9 50%, #f0f4fa 100%);
  margin-bottom: 1rem;
}

.ebook-balance-card-inner {
  padding: 1.35rem 1.25rem 1.5rem;
}

@media (min-width: 576px) {
  .ebook-balance-card-inner {
    padding: 1.75rem 1.75rem 1.85rem;
  }
}

.ebook-balance-header {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.35rem;
}

.ebook-balance-header-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: var(--ebook-accent-soft);
  color: var(--ebook-accent);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ebook-balance-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--ebook-ink);
  letter-spacing: -0.02em;
  margin: 0 0 0.35rem;
  line-height: 1.2;
}

.ebook-balance-subtitle {
  font-size: 0.9rem;
  color: var(--ebook-muted);
  margin: 0;
  line-height: 1.45;
  max-width: 36rem;
}

.ebook-balance-body {
  margin-bottom: 0.25rem;
}

.ebook-balance-text {
  font-size: 0.95rem;
  color: var(--ebook-ink);
  line-height: 1.5;
  margin-bottom: 0.75rem;
}

.ebook-balance-text-muted {
  color: var(--ebook-muted);
  margin-bottom: 0;
}

.ebook-balance-amounts {
  font-size: 0.9rem;
  color: var(--ebook-muted);
  line-height: 1.55;
  margin-bottom: 1.25rem;
}

.ebook-balance-amounts strong {
  color: var(--ebook-accent);
}

.ebook-balance-confirm-btn {
  width: 100%;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 0.65rem 1rem;
  background: var(--ebook-accent);
  border: none;
  color: #fff;
  transition: background 0.2s ease, transform 0.15s ease, opacity 0.2s ease;
}

.ebook-balance-confirm-btn:hover:not(:disabled) {
  background: #361a47;
  color: #fff;
}

.ebook-balance-confirm-btn:active:not(:disabled) {
  transform: scale(0.99);
}

.ebook-balance-confirm-btn:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

.ebook-balance-footnote {
  font-size: 0.8rem;
  color: var(--ebook-muted);
  margin: 1.35rem 0 0;
  padding-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  line-height: 1.5;
  margin-bottom: 0;
}

.ebook-balance-loading {
  min-height: 4rem;
}

/* Pago */
.ebook-paid-card {
  border: var(--ebook-card-border);
  background: #fff;
}

.ebook-paid-body {
  padding: 1.5rem 1.25rem;
  text-align: center;
}

@media (min-width: 576px) {
  .ebook-paid-body {
    padding: 2rem;
  }
}

.ebook-paid-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--ebook-ink);
  margin-bottom: 0.35rem;
}

.ebook-paid-text {
  font-size: 0.95rem;
  color: var(--ebook-muted);
  margin-bottom: 1rem;
}

.ebook-paid-btn {
  font-weight: 600;
}
</style>
